export default {
	"autoLineStrategy": {
		"cantEmpty": "不能为空",
		"algoModel": "算法模型",
		"name": "策略名称",
		"remark": "说明",
		"tabHeader": "策略信息",
		"useTimeWindow": "是否考虑时间窗",
		"multTemp": "是否多温层运输",
		"noSystemLog": "不看系统操作的数据",
		"dialogTitle": "添加自动排线策略",
		"carSetting": "车辆设置",
		"fullLoadUpper": "车辆满载率上限",
		"fullLoadLower": "车辆满载率下限",
		"lightRatio": "泡重比(方/吨)",
		"maxTransDuration": "最长运输作业时间",
		"lineSetting": "线路设置",
		"relativeDistanceWeight": "相对距离权重",
		"relativeDistance": "相对距离基值",
		"deliveryPositionUpper": "配送串点数上限",
		"incideMaxDistanceRatio": "捎带最大距离比",
		"regionUpper": "区域数上限",
		"planBeginExcuteTime": "计划执行开始时间",
		"wharfWorkSpeed": "码头吞吐速度",
		"defaultUnloadSpeed": "默认卸货速度",
		"defaultJoinTime": "默认交接时间",
		"recSendTitle": "收发货设置",
		"onlyEnableStrategySelectTips": "只能选择启用状态的策略"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/autoLineStrategy/autoLineStrategy.js